<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="alert-wrapper">
                <alert-container :messages="msgs" />
            </div>
            <div class="page">
                <div class="assuntortr vertical-flow">
                    <div class="listing-header">
                        <!-- TITULO E BREADCRUMB -->
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('atendimentos-agricola') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('vendas') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('crm') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('atendimentos-agricola') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <!-- BOTÕES -->
                        <div class="header-buttons">
                            <!-- BOTÕES DA EXPORTAÇÃO -->
                            <div v-if="exportacaoTipo && permissao.export" class="column is-3">
                                <div class="exportIcons" style="justify-content: flex-end">
                                    <div
                                        v-if="exportacaoTipo.exportaemail == 1"
                                        class="export-icon"
                                        @click="openModalExport('email')"
                                    >
                                        <b-icon
                                            icon="email-outline"
                                            size="is-medium"
                                            class="is-medium is-clickable"
                                            v-tippy
                                            :title="$t('msg-tooltip-email')"
                                        />
                                    </div>
                                    <div
                                        v-if="exportacaoTipo.exportawhatsapp == 1"
                                        class="export-icon"
                                        @click="openModalExport('whatsapp')"
                                    >
                                        <b-icon
                                            icon="whatsapp"
                                            size="is-medium"
                                            class="is-medium is-clickable"
                                            v-tippy
                                            :title="$t('msg-tooltip-whatsapp')"
                                        />
                                    </div>
                                    <div
                                        v-if="exportacaoTipo.exportapdf == 1"
                                        class="export-icon"
                                        @click="openModalExport('pdf')"
                                    >
                                        <b-icon
                                            icon="file-pdf"
                                            size="is-medium"
                                            class="is-medium is-clickable"
                                            v-tippy
                                            :title="$t('msg-tooltip-pdf')"
                                        />
                                    </div>
                                    <div
                                        v-if="exportacaoTipo.exportaexcel == 1"
                                        class="export-icon"
                                        @click="openModalExport('excel')"
                                    >
                                        <b-icon
                                            icon="file-excel"
                                            size="is-medium"
                                            class="is-medium is-clickable"
                                            v-tippy
                                            :title="$t('msg-tooltip-excel')"
                                        />
                                    </div>
                                    <div
                                        v-if="exportacaoTipo.exportacsv == 1"
                                        class="export-icon"
                                        @click="openModalExport('csv')"
                                    >
                                        <b-icon
                                            icon="file"
                                            size="is-medium"
                                            class="is-medium is-clickable"
                                            v-tippy
                                            :title="$t('msg-tooltip-csv')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline is-variable is-12">
                        <div class="column is-6">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>
                        <div class="column is-3">
                            <verified-date-picker
                                dateType="startDate"
                                :value="filter.datainicial"
                                :endDate="filter.datafinal"
                                title="data-inicio"
                                :addDateYears="2"
                                :subtractDateYears="2"
                                @input="changeStartDate"
                            />
                        </div>
                        <div class="column is-3">
                            <verified-date-picker
                                dateType="endDate"
                                :value="filter.datafinal"
                                :startDate="filter.datainicial"
                                :addDateYears="2"
                                :subtractDateYears="2"
                                title="data-fim"
                                @input="changeEndDate"
                            />
                        </div>
                    </div>

                    <!-- FILTROS EXTRAS -->
                    <div class="filtros-extras" style="padding-bottom: 25px">
                        <FiltroAtendimento @update-filtro="updateFiltro" ref="filtroRef" />
                    </div>

                    <div class="columns mt-0 mb-3">
                        <div class="control-buttons">
                            <div class="ctrl">
                                <button
                                    class="delete-btn pl-4 pr-4"
                                    type="button"
                                    @click="confirmCleanFilters"
                                >
                                    {{ $t('limpar-filtros') }}
                                </button>
                            </div>
                            <div class="ctrl">
                                <button
                                    class="save-btn pl-4 pr-4"
                                    type="button"
                                    @click="carregarDados(1)"
                                >
                                    {{ $t('pesquisar') }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- MODALS -->
                    <b-modal
                        class="export-20"
                        :active.sync="showMsgList"
                        style="z-index: 1000"
                        @close="onCancelExport()"
                    >
                        <div class="modal-card modal-default center" style="max-width: 580px">
                            <section class="modal-card-body">
                                <div class="listing-header">
                                    <div class="title-breadcrumb center">
                                        <h1 class="title">{{ $t('exportacao-dados') }}</h1>
                                    </div>
                                </div>
                                <div class="columns p-4">
                                    {{ $t('msg-exportacao-lista') }}
                                </div>
                                <div class="columns ok">
                                    <div class="form-buttons2">
                                        <button
                                            class="delete-btn"
                                            type="button"
                                            @click="onCancelExport()"
                                        >
                                            {{ $t('cancelar') }}
                                        </button>
                                        <button
                                            class="save-btn"
                                            type="button"
                                            @click="exibeModalOpcoes()"
                                        >
                                            {{ $t('continuar-exp') }}
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </b-modal>
                    <b-modal
                        class="export-filtros"
                        :active.sync="showMsgFilters"
                        style="z-index: 1000"
                        @close="onCancelExport()"
                    >
                        <div class="modal-card modal-default center" style="max-width: 580px">
                            <section class="modal-card-body">
                                <div class="listing-header">
                                    <div class="title-breadcrumb center">
                                        <h1 class="title">{{ $t('exportacao-dados') }}</h1>
                                    </div>
                                </div>
                                <div class="columns p-4">
                                    {{ $t('msg-campos-obrigatorios-filtro') }}
                                </div>
                                <div class="columns ok">
                                    <div class="form-buttons2">
                                        <button
                                            class="delete-btn"
                                            type="button"
                                            @click="onCancelExport()"
                                        >
                                            {{ $t('ok') }}
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </b-modal>
                    <b-modal
                        class="export-opcoes"
                        :active.sync="isShowingExport"
                        style="z-index: 1000"
                        @close="onCancelExport()"
                    >
                        <div class="modal-card modal-default center" style="max-width: 580px">
                            <section class="modal-card-body">
                                <div class="listing-header">
                                    <div class="title-breadcrumb center">
                                        <h1 class="title">{{ $t('exportacao-dados') }}</h1>
                                    </div>
                                </div>
                                <div class="columns p-4">
                                    {{ $t('msg-opcoes-exp') }}
                                </div>
                                <div class="columns p-4 space-around is-flex-wrap">
                                    <div class="column is-two-fifths">
                                        <b-checkbox
                                            v-model="hasAtendimentos"
                                            @input="updateOpcoesExportacao()"
                                            class="check-box"
                                            >Atendimentos</b-checkbox
                                        >
                                    </div>
                                    <div class="column is-two-fifths">
                                        <b-checkbox
                                            v-model="hasRtr"
                                            @input="updateOpcoesExportacao()"
                                            class="check-box"
                                            >AgroVisita</b-checkbox
                                        >
                                    </div>
                                    <div class="column is-two-fifths">
                                        <b-checkbox
                                            v-model="hasFotosAtendimentos"
                                            :disabled="!hasAtendimentos"
                                            @input="updateOpcoesExportacao()"
                                            class="check-box"
                                            v-if="this.tipoExportacao != 'csv'"
                                            >Fotos atendimentos</b-checkbox
                                        >
                                    </div>
                                    <div class="column is-two-fifths">
                                        <b-checkbox
                                            v-model="hasFotosRtr"
                                            :disabled="!hasRtr"
                                            @input="updateOpcoesExportacao()"
                                            class="check-box"
                                            v-if="this.tipoExportacao != 'csv'"
                                        >
                                            Fotos AgroVisita
                                        </b-checkbox>
                                    </div>
                                </div>
                                <div class="columns ok">
                                    <div class="form-buttons2">
                                        <button
                                            class="delete-btn"
                                            type="button"
                                            @click="onCancelExport()"
                                        >
                                            {{ $t('cancelar') }}
                                        </button>
                                        <button
                                            class="save-btn"
                                            type="button"
                                            @click="validaOpcoes()"
                                        >
                                            {{ $t('prosseguir') }}
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </b-modal>
                    <b-modal
                        class="export-opcoes"
                        :active.sync="isShowingTitle"
                        style="z-index: 1000"
                        @close="onCancelExport()"
                    >
                        <div class="modal-card modal-default center" style="max-width: 580px">
                            <section class="modal-card-body">
                                <div class="listing-header">
                                    <div class="title-breadcrumb center">
                                        <h1 class="title">{{ $t('exportacao-dados') }}</h1>
                                    </div>
                                </div>
                                <div class="columns p-4">
                                    {{ $t('title-exp') }}
                                </div>
                                <div class="columns is-full mx-1">
                                    <div class="titulo-input">
                                        <v-input
                                            v-model="tituloExportacao"
                                            :maxlength="100"
                                            :title="'titulo-exp'"
                                            :msg="'msg-campo-obrigatorio'"
                                        />
                                    </div>
                                </div>
                                <div class="columns ok">
                                    <div class="form-buttons2">
                                        <button
                                            class="delete-btn"
                                            type="button"
                                            @click="onCancelExport()"
                                        >
                                            {{ $t('cancelar') }}
                                        </button>
                                        <button
                                            class="save-btn"
                                            type="button"
                                            @click="saveExportacao()"
                                        >
                                            {{ $t('exportar-rel') }}
                                        </button>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </b-modal>

                    <!-- LISTAGEM -->
                    <div class="assuntortr-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            class="data-table"
                            :data="atendimentos"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.label ? $t(f.label) : ''"
                                :width="f.width"
                                :centered="f.centered"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                            >
                                <template v-slot:header>
                                    <span v-if="f.key == 'motivo'">
                                        {{ $t('motivo') }}
                                        <div class="table-sep" />
                                        {{ $t('data-atendimento') }}
                                        <b-icon
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`"
                                            size="is-small"
                                        />
                                    </span>
                                    <span v-else-if="f.key == 'cliente'">
                                        {{ $t('cliente') }}
                                        <div class="table-sep" />
                                        {{ $t('cidade') }}
                                        <b-icon
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`"
                                            size="is-small"
                                        />
                                    </span>
                                    <span v-else-if="f.key == 'propriedade'">
                                        {{ $t('propriedade') }}
                                        <div class="table-sep" />
                                        {{ $t('contato') }}
                                        <b-icon
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`"
                                            size="is-small"
                                        />
                                    </span>
                                    <span v-else-if="f.key == 'vendedor'">
                                        {{ $t('vendedor') }}
                                        <div class="table-sep" />
                                        {{ $t('finalizado-em') }}
                                        <b-icon
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`"
                                            size="is-small"
                                        />
                                    </span>
                                    <span v-else>
                                        {{ f.label ? $t(f.label) : '' }}
                                        <b-icon
                                            v-if="f.iconeAtivo"
                                            :icon="`arrow-${f.order == 'asc' ? 'up' : 'down'}`"
                                            size="is-small"
                                        />
                                    </span>
                                </template>

                                <template v-slot="props">
                                    <div v-if="f.key == 'idatendimentoagricola'">
                                        <b>{{ props.row.idatendimentoagricola }}</b>
                                    </div>
                                    <div v-else-if="f.key == 'motivo'">
                                        <router-link
                                            :to="{
                                                name: 'edit-venda-atendimento-agricola',
                                                params: { id: props.row.idatendimentoagricola },
                                            }"
                                        >
                                            <b>
                                                {{
                                                    props.row.motivoAtendimento
                                                        ? props.row.motivoAtendimento.descricao
                                                        : '---'
                                                }}
                                            </b>
                                        </router-link>
                                        <br />
                                        {{ props.row.dataAtendimento | moment('L') }}
                                    </div>

                                    <div v-else-if="f.key == 'cliente'">
                                        <router-link
                                            :to="{
                                                name: 'edit-venda-atendimento-agricola',
                                                params: { id: props.row.idatendimentoagricola },
                                            }"
                                        >
                                            <b>{{
                                                props.row.cliente
                                                    ? props.row.cliente.rsocial
                                                    : '---'
                                            }}</b>
                                        </router-link>
                                        <br />
                                        {{
                                            props.row.cliente
                                                ? props.row.cliente.cidade
                                                    ? props.row.cliente.cidade.descricao
                                                    : '---'
                                                : '---'
                                        }}
                                    </div>
                                    <div v-else-if="f.key == 'propriedade'">
                                        <b>{{
                                            props.row.propriedade
                                                ? props.row.propriedade.nome
                                                : '---'
                                        }}</b>
                                        <br />
                                        {{ props.row.contato ? props.row.contato : '---' }}
                                    </div>
                                    <div v-else-if="f.key == 'vendedor'">
                                        <b>{{
                                            props.row.usuario ? props.row.usuario.nome : '---'
                                        }}</b>
                                        <br />
                                        {{
                                            props.row.datahoraFinalizado
                                                ? $moment(props.row.datahoraFinalizado).format(
                                                      'L LT'
                                                  )
                                                : '---'
                                        }}
                                    </div>
                                    <div
                                        class="is-flex is-flex-centered"
                                        v-else-if="f.key == 'hasRtr'"
                                    >
                                        <b-tag
                                            v-if="props.row.hasRtr"
                                            type="is-primary"
                                            v-tippy
                                            :title="$t('msg-tooltip-agro-visita')"
                                        >
                                            {{ $t('agro-visita') }}
                                        </b-tag>
                                        <b-icon
                                            v-if="props.row.qtdFotos > 0"
                                            class="has-badge-primary mt-1"
                                            :class="{ 'ml-2': props.row.hasRtr }"
                                            icon="camera"
                                            :data-badge="props.row.qtdFotos"
                                            v-tippy
                                            :title="
                                                $t('msg-tooltip-n-fotos', { n: props.row.qtdFotos })
                                            "
                                        />
                                    </div>
                                    <div v-else>
                                        {{ props.row[f.key] }}
                                    </div>
                                </template>
                            </b-table-column>
                        </b-table>
                    </div>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import AtendimentoAgricolaService from '@/services/AtendimentoAgricolaService';
import VendasClienteService from '@/services/VendasClienteService';
import MotivoAtendimentoService from '@/services/MotivoAtendimentoAgricolaService';
import Message from '@/models/Message';
import ColaboradorService from '@/services/ColaboradorService';
import PropriedadeService from '@/services/agro/PropriedadeService';
import CultivarService from '@/services/agro/CultivarService';
import FiltroAtendimento from '@/components/vendas/atendimento/old/FiltroAtendimento';
/********* exportação *********/
import ExportacaoTipoService from '@/services/ExportacaoTipoService';
import ExportacaoService from '@/services/ExportacaoService';
import ExportacaoLogService from '@/services/ExportacaoLogService';
import ExportacaoDadosService from '@/services/ExportacaoDadosService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada.
 * Usar AtendimentoList ao inves.
 */
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('venda-atendimento') && to.name != 'venda-atendimentos-agricola') {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
            next();
        }
    },
    components: {
        ContainerLoader,
        FiltroAtendimento,
    },
    data() {
        return {
            rotaAninhada: false,
            atendimentos: [],
            service: new AtendimentoAgricolaService(this.$http, this.$router),
            clienteService: new VendasClienteService(this.$http, this.$router),
            motivoService: new MotivoAtendimentoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router), // vendedor
            propriedadeService: new PropriedadeService(this.$http, this.$router),
            /********* exportação *********/
            exportacaoTipoService: new ExportacaoTipoService(this.$http, this.$router),
            exportacaoService: new ExportacaoService(this.$http, this.$router),
            exportacaoLogService: new ExportacaoLogService(this.$http, this.$router),
            exportacaoDadosService: new ExportacaoDadosService(this.$http, this.$router),
            fields: [
                {
                    key: 'idatendimentoagricola',
                    label: 'codigo',
                    sortable: true,
                    centered: true,
                    width: 100,
                    order: 'desc',
                    iconeAtivo: false,
                },
                {
                    key: 'motivo',
                    label: 'motivo',
                    sortable: true,
                    width: '20%',
                    order: 'desc',
                    iconeAtivo: false,
                },
                {
                    key: 'cliente',
                    label: 'cliente',
                    sortable: true,
                    width: '20%',
                    order: 'desc',
                    iconeAtivo: false,
                },
                {
                    key: 'propriedade',
                    label: 'propriedade',
                    sortable: true,
                    width: '20%',
                    order: 'desc',
                    iconeAtivo: false,
                },
                {
                    key: 'vendedor',
                    label: 'vendedor',
                    sortable: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
                {
                    key: 'hasRtr',
                    label: '',
                    sortable: false,
                    centered: true,
                    order: 'desc',
                    iconeAtivo: false,
                },
            ],
            datasStart: {
                datainicial: (() => {
                    let trintaDiasAtras = new Date();
                    trintaDiasAtras.setDate(trintaDiasAtras.getDate() - 31);
                    return trintaDiasAtras;
                })(),
                datafinal: (() => {
                    let trintaDiasDepois = new Date();
                    trintaDiasDepois.setDate(trintaDiasDepois.getDate() + 31);
                    return trintaDiasDepois;
                })(),
            },
            filter: {
                datainicial: null,
                datafinal: null,
                cliente: null,
                motivo: null,
                possuiFotoAtendimento: null,
                possuiRtr: null,
                possuiFotoRtr: null,
                vendedores: [],
                propriedade: null,
                // cultivar: null,
                // cultura: null,
            },
            tituloExportacao: '',
            exportacao: {},
            nomeTela: 'ATENDIMENTOLISTA',
            exportacaoTipo: {},
            hasAtendimentos: false,
            hasFotosAtendimentos: false,
            hasRtr: false,
            hasFotosRtr: false,
            controleFotoRtr: false,
            controleCultura: false,
            clientes: [],
            clientesLoading: false,
            motivos: [],
            motivosLoading: false,
            vendedores: [],
            showMsgFilters: false,
            showMsgList: false,
            isShowingExport: false,
            isShowingTitle: false,
            vendedoresLoading: false,
            vendedoresSelecionados: [],
            propriedades: [],
            msgs: [],
            propriedadeLoading: false,
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            column: 'datahora',
            order: 'desc',
            modalOpen: false,
            tipoExportacao: '',
            possuiOpcoes: [
                { id: 1, label: 'Sim' },
                { id: 2, label: 'Não' },
                { id: 0, label: 'Todos' },
            ],
            possuiFotoAtendimento: { id: 0, label: 'Todos' },
            possuiRtr: { id: 0, label: 'Todos' },
            possuiFotoRtr: { id: 0, label: 'Todos' },
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        if (
            this.$route.name.includes('venda-atendimento') &&
            this.$route.name != 'venda-atendimentos-agricola'
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.setStartDates();
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'venda-atendimentos-agricola');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimentos-agricola' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
            this.carregaExportacaoTipo();
        }
    },
    methods: {
        setStartDates() {
            this.filter.datainicial = this.datasStart.datainicial;
            this.filter.datafinal = this.datasStart.datafinal;
        },
        changeStartDate(date) {
            this.filter.datainicial = date;
        },
        changeEndDate(date) {
            this.filter.datafinal = date;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            let filter = {
                datainicial: this.filter.datainicial
                    ? this.$moment(this.filter.datainicial).format('YYYY-MM-DD')
                    : null,
                datafinal: this.filter.datafinal
                    ? this.$moment(this.filter.datafinal).format('YYYY-MM-DD')
                    : null,
                propriedade: this.filter.propriedade ? this.filter.propriedade.uuid : null,
                cliente: this.filter.cliente ? this.filter.cliente.id : null,
                motivo: this.filter.motivo ? this.filter.motivo.id : null,
                possuiFotoAtendimento: this.filter.possuiFotoAtendimento
                    ? this.filter.possuiFotoAtendimento.id
                    : null,
                possuiFotoRtr: this.filter.possuiFotoRtr ? this.filter.possuiFotoRtr.id : null,
                possuiRtr: this.filter.possuiRtr ? this.filter.possuiRtr.id : null,
                vendedores: this.filter.vendedores
                    ? this.filter.vendedores.map((e) => e.idusuario)
                    : null,
                // cultivar: this.filter.cultivar ? this.filter.cultivar.id : null,
                // cultura: this.filter.cultura ? this.filter.cultura.id : null,
            };

            this.service
                .findAll(
                    filter,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.atendimentos = value;
                    this.isEmpty = this.atendimentos.length <= 0;
                })
                .catch((e) => {
                    console.error('Erro ao carregar Atendimentos AgrÃ­cola.', e);
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        exibeModalLista() {
            this.isShowingTitle = false;
            this.isShowingExport = false;
            this.showMsgFilters = false;
            this.showMsgList = true;
        },
        exibeModalFiltro() {
            this.isShowingTitle = false;
            this.isShowingExport = false;
            this.showMsgFilters = true;
            this.showMsgList = false;
        },
        exibeModalTitle() {
            this.isShowingTitle = true;
            this.isShowingExport = false;
            this.showMsgFilters = false;
            this.showMsgList = false;
        },
        exibeModalOpcoes() {
            this.isShowingTitle = false;
            this.isShowingExport = true;
            this.showMsgFilters = false;
            this.showMsgList = false;
        },
        onCancelExport() {
            this.isShowingExport = false;
            this.showMsgFilters = false;
            this.showMsgList = false;
            this.isShowingTitle = false;
        },
        openModalExport(tipo) {
            this.tipoExportacao = tipo;
            this.isShowingExport = false;
            this.showMsgFilters = false;
            this.showMsgList = false;
            if (this.filter.datainicial != null && this.filter.datafinal != null) {
                // Se possuir os filtros
                // Se tiver menos que 20
                if (this.pagination.totalRows < 20) {
                    this.exibeModalOpcoes();
                } else {
                    this.exibeModalLista();
                }
            } else {
                this.exibeModalFiltro();
            }
        },
        validaOpcoes() {
            if (this.hasAtendimentos || this.hasRtr) {
                this.exibeModalTitle();
            } else {
                this.exibeModalOpcoes();
                this.showMessage('error', 'msg-erro-obrigatorio-exportacao');
            }
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        updateOpcoesExportacao() {
            if (!this.hasAtendimentos) {
                this.hasFotosAtendimentos = false;
            }
            if (!this.hasRtr) {
                this.hasFotosRtr = false;
            }
        },
        mapItems(body) {
            if (body && body.content) {
                this.pagination.totalRows = body.totalElements;
                return body.content;
            } else {
                return [];
            }
        },
        confirmExclusion(item) {
            this.deleteThis = item;
            this.$root.confirm({
                message: this.$t('msg-confirmacao-exclusao-n', { n: item.descricao }),
                onConfirm: this.excluir,
                onCancel: (_) => {
                    this.deleteThis = null;
                },
            });
        },
        excluir() {
            let item = this.deleteThis;
            this.isLoading = true;
            this.service
                .delete(item.id)
                .then((_) => {
                    this.$root.showMessage('success', 'msg-success-excluir-atendimentoagricola');
                    this.carregarDados(this.pagination.currentPage);
                })
                .catch((e) => {
                    console.error('Erro ao excluir atendimento.', e);
                    this.$root.showMessage('error', 'msg-failure-excluir-atendimentoagricola');
                    this.isLoading = false;
                })
                .finally((_) => {
                    this.deleteThis = null;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;

            this.fieldAnterior
                ? (this.fields.find((obj) => obj.key == this.fieldAnterior).iconeAtivo = false)
                : (this.fieldAnterior = field);

            let fieldItem = this.fields.find((obj) => obj.key == field);
            fieldItem.order = this.order;
            fieldItem.iconeAtivo = true;

            this.fieldAnterior = field;
            this.carregarDados();
        },

        limparFiltros() {
            this.filter.propriedade = null;
            this.filter.cliente = null;
            // this.filter.cultura = null;
            // this.filter.cultivar = null;
            this.filter.motivo = null;
            this.filter.vendedores = [];
            this.filter.possuiFotoAtendimento = { id: 0, label: 'Todos' };
            this.filter.possuiRtr = { id: 0, label: 'Todos' };
            this.filter.possuiFotoRtr = { id: 0, label: 'Todos' };

            this.propriedades = [];
            this.queryFilter = '';
            (this.possuiFotoAtendimento = { id: 0, label: 'Todos' }),
                (this.possuiFotoRtr = { id: 0, label: 'Todos' }),
                (this.possuiRtr = { id: 0, label: 'Todos' });
            this.carregarDados();
            this.$refs.filtroRef.limparFiltrosSelecionados();
        },
        carregarClientes(q) {
            this.clientesLoading = true;
            this.clienteService
                .listAll(20, q)
                .then((r) => {
                    this.clientes = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de clientes. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.clientesLoading = false;
                });
        },
        carregarMotivos(q) {
            this.motivosLoading = true;
            this.motivoService
                .findAll()
                .then((r) => {
                    this.motivos = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de motivos. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.motivosLoading = false;
                });
        },
        carregarVendedores(q) {
            this.vendedoresLoading = true;

            this.colaboradorService
                .findListAssociated(q)
                .then((r) => {
                    this.vendedores = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de vendedores. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        updateVendedor(vendedoresSelecionados) {
            if (vendedoresSelecionados) {
                this.filter.vendedores = vendedoresSelecionados;
                this.carregarDados();
            } else {
                this.filter.vendedores = null;
                this.carregarDados();
            }
        },
        updateFiltro(filtro) {
            let nome = filtro.nomeFiltro;
            switch (nome) {
                case 'cliente':
                    this.filter.cliente = filtro.valor;
                    break;
                case 'propriedade':
                    this.filter.propriedade = filtro.valor;
                    break;
                case 'motivo':
                    this.filter.motivo = filtro.valor;
                    break;
                case 'possuiFotoAtendimento':
                    this.filter.possuiFotoAtendimento = filtro.valor;
                    break;
                case 'possuiRtr':
                    this.filter.possuiRtr = filtro.valor;
                    break;
                case 'possuiFotoRtr':
                    this.filter.possuiFotoRtr = filtro.valor;
                    break;
                case 'vendedores':
                    this.filter.vendedores = filtro.valor;
                    break;
                // case 'cultura':
                //     this.filter.cultura = filtro.valor;
                //     break;
                // case 'cultivar':
                //     this.filter.cultivar = filtro.valor;
                //     break;
            }
        },
        carregarPropriedades(q) {
            if (this.filter.cliente && this.filter.cliente.id > 0) {
                this.propriedadesLoading = true;
                this.propriedadeService
                    .listAllByIdCliente(this.filter.cliente.id, 50, 0, q)
                    .then((r) => {
                        let propriedades = [];
                        propriedades[0] = {
                            id: null,
                            nome: 'SEM PROPRIEDADE',
                        };
                        this.propriedades = propriedades.concat(r.content);
                    })
                    .catch((e) => {
                        console.error(
                            `Erro ao realizar pesquisa de propriedades. Termo: [${q}]`,
                            e
                        );
                    })
                    .finally((_) => {
                        this.propriedadesLoading = false;
                    });
            }
        },
        updateValue(val) {
            if (
                !val ||
                (val && this.filter && this.filter.cliente && this.filter.cliente.id != val.id)
            ) {
                this.atendimentos.propriedade = {};
                this.filter.propriedade = {};
                this.propriedades = [];
            }
            this.filter.cliente = val;
            this.carregarPropriedades();
        },
        /**************** EXPORTAÃ‡ÕES ***************** */
        carregaExportacaoTipo() {
            // Inidica qual a tela que será passada (ENUM ExportacaoTelas) para realizar a busca
            this.exportacaoTipoService.findByTela(this.nomeTela).then((body) => {
                if (body.content) {
                    this.exportacaoTipo = body.content;
                }
            });
        },
        validaTituloExportacao() {
            let valido = true;
            if (!this.tituloExportacao || this.tituloExportacao.trim() == '') {
                valido = false;
                this.showMessage('alert', 'msg-valida-titulo');
            }

            return valido;
        },
        confirmCleanFilters() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-filtros'),
                onConfirm: this.limparFiltros,
            });
        },

        /// Cria o objeto exportação e envia o mesmo para o banco.
        saveExportacao() {
            if (this.validaTituloExportacao()) {
                this.isSaving = true;

                let exportacao = {
                    idexportacao: null,
                    titulo: this.tituloExportacao,
                    processoexportado: this.tipoExportacao,
                    situacao: 'EXPORTANDO',
                    usuario: {
                        idusuarioerp: this.$store.state.user.idusuarioerp,
                    },
                    exportacaotipo: {
                        idexportacaotipo: this.exportacaoTipo.idexportacaotipo, //IDEXPORTACAOTIPO (REFERE-SE A QUAL TELA ESTA CHAMANDO A EXPORTACAO)
                    },
                };
                this.exportacaoService
                    .save(exportacao)
                    .then((response) => {
                        this.$root.showMessage('success', 'msg-exp-solicitada');
                        ///Chama o savelog e passa o tipo da exportação (whats, pdf, csv...)
                        this.saveLog(response.content, this.tipoExportacao);
                        this.gerarArquivoExportacao(response.content);
                    })
                    .catch((e) => {
                        console.error('Erro ao salvar exportação.', e);
                        this.$root.showMessage('error', 'msg-erro-exp-gerar');
                    })
                    .finally((_) => {
                        this.isSaving = false;
                        this.onCancelExport();
                    });
            }
        },
        /// Salva os dados na tabela fvw_exportacaolog
        saveLog(exportacao, tipo) {
            let exportacaoLog = {
                ///Objeto criado que será enviado ao banco
                destino: null,
                acao: 'Solicitação da exportação listagem ' + tipo,
                exportacao: exportacao,
                usuario: {
                    idusuarioerp: exportacao.usuario.idusuarioerp,
                },
            };

            this.exportacaoLogService
                .save(exportacaoLog)
                .then((r) => {})
                .catch((e) => {
                    console.error('Erro ao salvar log exportação.', e);
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },
        gerarArquivoExportacao(exportacao) {
            let exportacaoAtendimentos = {
                // A listagem de atendimentos será consultada no back
                listatendimentos: null,
                exportacao: exportacao,
                // O que será exportado
                exportaAtendimento: this.hasAtendimentos,
                exportaRtr: this.hasRtr,
                exportaFotosAtendimento: this.hasFotosAtendimentos,
                exportaFotosRtr: this.hasFotosRtr,
                usuario: this.$store.state.user,
                hasRtr: this.hasRtr,
                filtro: {
                    datainicial: this.filter.datainicial
                        ? this.$moment(this.filter.datainicial).format('YYYY-MM-DD')
                        : null,
                    datafinal: this.filter.datafinal
                        ? this.$moment(this.filter.datafinal).format('YYYY-MM-DD')
                        : null,
                    propriedade: this.filter.propriedade ? this.filter.propriedade.id : null,
                    cliente: this.filter.cliente ? this.filter.cliente.id : null,
                    motivo: this.filter.motivo ? this.filter.motivo.id : null,
                    possuiFotoAtendimento: this.filter.possuiFotoAtendimento
                        ? this.filter.possuiFotoAtendimento.id
                        : null,
                    possuiFotoRtr: this.filter.possuiFotoRtr ? this.filter.possuiFotoRtr.id : null,
                    possuiRtr: this.filter.possuiRtr ? this.filter.possuiRtr.id : null,
                    vendedores: this.filter.vendedores
                        ? this.filter.vendedores.map((e) => e.idusuario)
                        : [],
                    column: this.column,
                    order: this.order,
                    search: this.queryFilter,
                },
            };
            // validação para saber qual service irá chamar para gerar as exportacoes
            this.exportacaoDadosService
                .saveAtendimentoOld(exportacaoAtendimentos, 1, this.tipoExportacao)
                .then((this.tituloExportacao = ''))
                .catch((e) => {
                    console.error('Erro ao salvar exportação ', this.tipoExportacao, e);
                    this.$root.showMessage('error', 'msg-erro-exp-gerar');
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;
}

.calendar-btn {
    padding: 0;
    width: 100px;
    height: 35px;
}

.ok {
    margin: 0;
}
.text-content {
    vertical-align: middle;
}
.center {
    align-content: center;
}
.control-buttons {
    margin: 0;
}

.exportIcons {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
}

.export-icon {
    color: var(--primary-color);
    padding-right: 1rem;
}

.space-around {
    justify-content: space-around;
    text-align: start;
}

.titulo-input {
    width: 100%;
}

.form-buttons2 {
    top: 20px;
    display: flex;
    margin: 0 auto;

    .save-btn,
    .delete-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $sovis-white;
        font-size: 12px;
        height: 47px;
        padding: 15px 40px;
        border: none;
        border-radius: 6px;
        font-weight: 600;
        margin-left: 20px !important;
        @include gradient-button();
    }

    .delete-btn {
        right: 225px;
        color: $darker-gray-color;
        @include exclude-button();
    }
}

.filtros-extras {
    font-size: 12px;
}

.modal {
    display: flex;
    justify-content: center;
}

.modal-content {
    width: 40% !important;
}

.modal-card {
    width: auto !important;
}

.control-buttons {
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    width: 100%;
    height: 30px;
}

button.btn-search {
    height: 47px;
    width: 150px;
    font-size: 12px;
    color: $sovis-white;
    @include gradient-button();
}
</style>
